import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { PagesModule } from './core/pages/pages.module';
import { InterceptorService } from './core/services/interceptor.service';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './core/services/http.service';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';

/**
 * Get HttpService based on env value
 *
 * @param {HttpClient} http HttpClient
 * @returns {HttpService} Real or mock service
 */

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    PagesModule,
    SharedModule,
    AppRoutingModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    {
      provide: HttpService,
      deps: [HttpClient]
    }
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
